import { QueryClient } from "@tanstack/react-query";
import { isApiError, isContractError } from "@/api/client";

export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 15_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: true,
        retry: (count, err) => {
          // Missing contract operations and client errors won't fix themselves.
          if (isContractError(err)) return false;
          if (isApiError(err) && err.status >= 400 && err.status < 500 && err.status !== 429) return false;
          return count < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}
